module.exports = __webpack_public_path__ + "img/50.058bf420.png";